/* eslint-disable react/display-name */
import React from 'react';

import './SupportWidget.scss';

const config = {
  phoneNumber: '', //1-800-285-7995
  email: '', // support@nextos.com
  link: 'https://www.nextiva.com/support/',
  chatLink: '',
};

const SupportWidget = {
  popoverBody: () => {
    const callLink = `tel:+${config.phoneNumber}`;
    const emailLink = `mailto:${config.email}`;
    const cls = (...classes) => classes.map((c) => `nx-support-widget__${c}`).join(' ');
    const boldOptionClassName = cls('option-text', 'option-text--strong');
    const blueOptionClassName = cls('option-text', 'option-text--blue');

    const openLink = (link) => {
      window.open(link, '_blank');
    };

    return (
      <div className="nx-support-widget">
        <div className="nx-support-widget__title">Contact Support</div>
        <div className="nx-support-widget__hr" />
        {config.phoneNumber && (
          <span className="nx-support-widget__option" onClick={() => openLink(callLink)}>
            <span className={boldOptionClassName}>Call</span>
            &nbsp; {config.phoneNumber}
          </span>
        )}
        {config.email && (
          <span className="nx-support-widget__option" onClick={() => openLink(emailLink)}>
            <span className={boldOptionClassName}>Email</span>
            &nbsp;
            <span className={blueOptionClassName}>{config.email}</span>
          </span>
        )}
        {config.link && (
          <span className="nx-support-widget__option" onClick={() => openLink(config.link)}>
            <span className={boldOptionClassName}>nextiva.com/support</span>
          </span>
        )}
        <span className="nx-support-widget__option" onClick={() => openLink('https://status.nextiva.com/')}>
          <span className={boldOptionClassName}>View System Status</span>
        </span>
        {!!config.chatLink && (
          <span className="nx-support-widget__option" onClick={() => openLink(config.chatLink)}>
            <span className={blueOptionClassName}>Chat</span>
            &nbsp;with Support Now
          </span>
        )}
      </div>
    );
  },
  isActive: () => true,
  onClickHandler: () => null,
};

export default SupportWidget;
